import * as React from 'react';

import DiscoveryContentFiltersStateHandler from './state/DiscoveryContentFiltersStateHandler';
import DiscoveryContentFiltersHeader from './header/DiscoveryContentFiltersHeader';
import DiscoveryContentFiltersTimeframe from './timeframe/DiscoveryContentFiltersTimeframe';
import DiscoveryContentFiltersCountries from './location/countries/DiscoveryContentFiltersCountries';
import DiscoveryContentFiltersGender from './gender/DiscoveryContentFiltersGender';
import DiscoveryContentFiltersFollowers from './followers/DiscoveryContentFiltersFollowers';
import DiscoveryContentFiltersProfiles from './profiles/DiscoveryContentFiltersProfiles';

import './discovery-content-filters.scss';

type Props = {
  onToggleFilters: () => void,
  onResetFilters: () => void
};

class DiscoveryContentFilters extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { onToggleFilters, onResetFilters } = this.props;

    return (
      <div className="discovery-content-filters">
        <DiscoveryContentFiltersStateHandler
          onResetFilters={onResetFilters}
        >
          <DiscoveryContentFiltersHeader
            onToggleFilters={onToggleFilters}
          />
          <DiscoveryContentFiltersTimeframe />
          <DiscoveryContentFiltersCountries />
          <DiscoveryContentFiltersGender />
          <DiscoveryContentFiltersFollowers />
          <DiscoveryContentFiltersProfiles />
        </DiscoveryContentFiltersStateHandler>
      </div>
    );
  }
}

export default DiscoveryContentFilters;
